import { Component, Optional } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListView } from '../../../../icemedx-lib/src/components/baseview.component';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelService } from '../../../../icemedx-lib/src/components/icepanel/icepanel.service';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcepanelDialog } from '../../../../icemedx-lib/src/components/icepaneldialog/icepaneldialog';
import { iceColumnDefinition, IcecontrolPermission, IcecontrolSettings, IcepanelcontainerSettings, IcepanelsectionSettings, IcepanelSettings } from '../../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { chargehistory } from '../../../../icemedx-lib/src/models/accounting/chargehistory';
import { incomerevenuejournal } from '../../../../icemedx-lib/src/models/accounting/incomerevenuejournal';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { medicalserviceindex } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalserviceindex';
import { medicalservicereference } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservicereference';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { superbillchargesindex } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillchargesindex';
import { payment } from '../../../../icemedx-lib/src/models/accounting/payment';
import { superbillindex } from '../../../../icemedx-lib/src/models/accounting/superbillindex';
import { IIceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { subscriber } from '../../../../icemedx-lib/src/models/domain/subscriber';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { basecodereference } from '../../../../icemedx-lib/src/models/ehr/subs/basecodereference';
import { subscriberreference } from '../../../../icemedx-lib/src/models/ehr/subs/subscriberreference';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { otheritemsindex } from '../../../../icemedx-lib/src/models/otheritems/otheritemsindex';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { BreadcrumType } from '../../../../icemedx-lib/src/services/baseapp.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { PayerService } from '../../../../icemedx-lib/src/services/payer/payer.service';
import { PharmacyService } from '../../../../icemedx-lib/src/services/pharmacy/pharmacy.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { VendorService } from '../../../../icemedx-lib/src/services/vendor/vendor.service';
import { AppService } from '../app.service';
import { BreadcrumbService } from '../../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';
import { AppConstants } from '../app-constants';

export enum ServiceViews {
  ViewByBucket = 1,
  ViewByService = 2,
  ViewByAged = 3,
  ViewByPayerBucket = 4,
  ViewByClaim = 5
}

const viewOptions = "viewOptions";
const domainType = "domainType";
const domainDesc = "domainDesc";
const keywordDesc = "keywordDesc";
const codeDesc = "codeDesc";
const filterButton = "filterButton";
const resetButton = "resetButton";

@Component({
  selector: 'app-servicechargehistory',
  templateUrl: './servicechargehistory.component.html',
  styleUrls: ['./servicechargehistory.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class ServicechargeHistoryComponent extends BaseListView {

  // member settings
  hideAccountingPeriod: boolean = true;

  viewOptions: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, viewOptions, "Select Bucket or Single View")
    .setControlName(viewOptions)
    .createFormControl(ServiceViews.ViewByBucket, [Validators.required]);

  domainTypeCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: DomainService.getDomainTypes(), width: "100%" }, null, null, domainType, "Type of Service Bucket")
    .setControlName(domainType)
    .createFormControl(IceTypes.ACCOUNT_TYPE.actPatient, []);

  domainCtrl: IcecontrolSettings = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%", enableAdvancedSearch: true }, null, null, domainDesc, "Enter " + DomainService.getDomainType(IceTypes.ACCOUNT_TYPE.actPatient))
    .setMultipleSelection(false)
    .setControlName(domainDesc)
    .createFormControl("", []);

  fromDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "From Date", width: "100%" }, null, null, "FromDate")
    .setControlName("FromDate")
    .createFormControl(null, []);
  toDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "To Date", width: "100%" }, null, null, "ToDate")
    .setControlName("ToDate")
    .createFormControl(null, []);

  keywordCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, keywordDesc, "Keyword")
    .setControlName(keywordDesc)
    .createFormControl("", []);

  codeCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, keywordDesc, "Code")
    .setControlName(codeDesc)
    .createFormControl("", []);

  statusCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: this.getAllStatuses(), width: "100%" }, null, null, "Status", "Status")
    .setControlName("Status")
    .createFormControl(-1, [])
    .setOptions(this.getAllStatuses());


  filterButton: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "Search", glyphClass: "fas fa-filter", width: "50px" }, null, null, filterButton);
  resetButton: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "Reset", glyphClass: "fas fa-sync", width: "50px" }, null, null, resetButton);
  subscriptionButton: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "Process Recurring Charge(s)", glyphClass: "fas fa-file", width: "100px" }, null, null, "subscriptionButton");

  currentView: ServiceViews = this.getDefaultView();
  currentCharge: medicalservice = null;
  currentChargeCaption = "Service Charge";
  currentBucket: superbillcharges = null;
  currentBucketChargeList: medicalservice[] = [];
  currentChargeAccountingHistory: any = {};
  currentChargeHistory: chargehistory = new chargehistory(null);

  patientSubRefs: subscriberreference[] = [];
  listOfPayerResponsibities: basecode[] = [];


  listOfServices = [];
  listOfInventory = [];
  responsibleParties: any[] = [];
  currentChargePanel: IcepanelSettings = new IcepanelSettings("", "", "", "", []);
  deleteTheseServices: medicalserviceindex[] = [];

  recurringChargesDialogRef: any = null;
  lastRecurringDomains: string = "";

  statementsViewSettings: IcepanelcontainerSettings = null;
  statementsPermission: IcecontrolPermission = null;
  deleteConfirmationDialogRef: any = null;
  breadcrumbService: BreadcrumbService;
  navOptions = { fragment: AppConstants.ServiceChargeHistoryPage };
  previousPage: string = "";

  constructor(appSvc: AppService,
    navSvc: IceNavService,
    private domainSvc: DomainService,
    private accSvc: AccountingService,
    loginSvc: LoginService,
    router: Router,
    private vendorSvc: VendorService,
    private proSvc: ProviderService,
    private pharmSvc: PharmacyService,
    private payerSvc: PayerService,
    private patSvc: PatientService,
    private codeSvc: MedicalcodesService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private breadcrumbSvc: BreadcrumbService,
    @Optional() panelSvc?: IcepanelService) {

    super(appSvc, loginSvc, navSvc, router, panelSvc);

    appSvc.defaultMenus();
    this.breadcrumbService = breadcrumbSvc;
    this.addBreadcrumbs();

    let feaAccess = appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;
    this.statementsPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufSuperBill, feaAccess);

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      return;
    }

    this.setInlineEditing(true);
    this.statementsViewSettings = this.viewSetup([], userTypes.USER_FEATURES.ufSuperBill);

    this.activatedRoute.queryParams.subscribe(params => {
      if (Iceutility.isdefined(params)) {
        let referrer = params["referrer"];

        if (referrer && referrer == "ledger") {
          this.breadcrumbService.updateBreadcrumb(BreadcrumType.btBranch.toString(), {
            display: "Ledger - Service Charge History",
            data: null,
            active: true,
            link: "",
            history: []
          });
        } else {
          this.breadcrumbService.updateBreadcrumb(BreadcrumType.btBranch.toString(), {
            display: this.getBreadCrumTitle(),
            data: null,
            active: true,
            link: "",
            history: []
          });
        }
      }
    });

    this.activatedRoute.fragment.subscribe(fragment => {
      if (Iceutility.isdefined(fragment)) {
        if (fragment == AppConstants.LedgerPage) {
          this.previousPage = AppConstants.LedgerPage;

          this.breadcrumbService.updateBreadcrumb(BreadcrumType.btBranch.toString(), {
            display: "Ledger - Service Charge History",
            data: null,
            active: true,
            link: "",
            history: []
          });
        }
      }
    });

    // Default search
    this.activatedRoute.params.subscribe(next => {
      if (next.byType != null) {
        // To do onActiveRouteByTypeParam(...)
        if (next.byType.toLowerCase() == "bybucket")
          this.currentView = ServiceViews.ViewByBucket;
        else if (next.byType.toLowerCase() == "byservice")
          this.currentView = ServiceViews.ViewByService;

        this.tables[0].iColumns = this.onGetColumnDefinition();
        this.tables[0].actionItems = this.onGetActionItems();
      }

      this.viewOptions.setOptions(this.getViewOptions());
      this.viewOptions.getFormControl().setValue(this.currentView);

      if (next.actType != null && next.actType.length > 0) {
        this.domainTypeCtrl.getFormControl().setValue(Iceutility.toLong(next.actType));
      }

      if (next.act != null && next.act.length > 0) {
        this.domainSvc.getPatient(next.act, this.getAppService().getCurrentAccount())
          .subscribe(result => {
            if (Iceutility.isdefined(result) && result.length > 0) {
              let patientName = "";
              let patient = result[0];
              let entity = Iceutility.isdefined(patient.ENTS) && patient.ENTS.length > 0 ? patient.ENTS[0] : null;
              if (entity) {
                patientName = `${entity.first_name} ${entity.last_name}`;
              }

              this.setContextFromBreadcrumb(next.act, patientName);
            }
          });
      }
      else {
        this.updateNetworkName();
      }
      this.onActiveRoute(next);
    });
  }

  getDefaultView(): ServiceViews {
    return ServiceViews.ViewByService;
  }

  onActiveRoute(next): void {
    if (this.currentView == ServiceViews.ViewByBucket) {
      this.searchBills();
    }
    else {
      if (this.disableSearchButton() == false)
        this.searchServices();
    }
  }

  addBreadcrumbs() {
    this.breadcrumbService.updateBreadcrumbs({
      TREE: this.getAccountingBreadcrumb(),
      BRANCH: { display: this.getBreadCrumTitle(), data: null, active: true, link: "", history: [] }
    }, "");
  }

  getAccountingBreadcrumb() {
    return { display: "Accounting", data: null, active: false, link: "/accounting/summary", history: [] };
  }

  getBreadcrumbs(): any {
    return this.breadcrumbService.getBreadcrumbs();
  }

  getBreadCrumTitle(): string {
    return "Service Charge History - List of services";
  }

  getAccountingService(): AccountingService {
    return this.accSvc;
  }

  getDomainService(): DomainService {
    return this.domainSvc;
  }

  getCodeService(): MedicalcodesService {
    return this.codeSvc;
  }

  ngOnInit() {
    this.getAppService().refreshMenus();

    this.domainCtrl.createAdvanceSearhControlEvent().subscribe(
      event => {
        this.patSvc.patientAdvanceSearch(this.dialog,
          this.getAppService().getCurrentAccount(),
          this.getAppService().getCurrentAccountType(), event.value).subscribe((result: any) => {
            if (result != null) {
              this.setContextFromBreadcrumb(result.record.trans_account, result.record.first_name);
            }
          });
      },
      error => { }
    );

    // get the breadcrumbs to see if there's a patient in the YARD
    let data: any = this.breadcrumbService.getYardData();
    if (Iceutility.isdefined(data.account) && Iceutility.isdefined(data.patientName)) {
      this.setContextFromBreadcrumb(data.account, data.patientName);
    }
  }

  setContextFromBreadcrumb(account: string, patientName: string) {
    this.domainCtrl.getFormControl().setValue(JSON.stringify([{ name: patientName, value: account }]));
    setTimeout(_ => {
      this.domainCtrl.setMultipleSelection(false);
    }, 200);
    this.refreshTableData([]);
    this.updateNetworkName(true);
    this.breadcrumbService.updateBreadcrumbs({
      TREE: this.getAccountingBreadcrumb(),
      YARD: {
        display: patientName,
        data: {
          account,
          patientName
        },
        active: true,
        link: `/accounting/servicechargehistory/${account}`,
        history: []
      }
    });
  }

  onToolbarMenuItemClick(event) {
    if (Iceutility.isdefined(event) && Iceutility.isdefined(event.selectedItem) && Iceutility.isdefined(event.selectedItem.data)) {
      const account = event.selectedItem.data.account;
      const patient = event.selectedItem.data.patientName;

      if (this.previousPage == AppConstants.LedgerPage) {
        this.getRouter().navigate([`/accounting/ledger`]);
      } else {
        this.setContextFromBreadcrumb(account, patient);
      }
    }
  }


  onGetColumnDefinition(): iceColumnDefinition[] {
    if (ServiceViews.ViewByBucket == this.currentView) {
      return [
        new iceColumnDefinition("bill_to", "Add Service Bucket", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("to_trans_account_text", "Network ID", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("to_account_type_text", "Type", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("bill_status_text", "Status", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("created", "Created Date", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("modified", "Mod. Date", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("QuickActions", "", false, false),
        new iceColumnDefinition("superbill_charges_index_key", "superbill_charges_index_key", false, true),
        new iceColumnDefinition("superbill_charges_key", "superbill_charges_key", true)
      ];
    }

    return [
      new iceColumnDefinition("service_description", "Service", false, false,
        new IcecontrolSettings("icelabel", { width: "125px" }, null, null)),
      new iceColumnDefinition("date_required", "Date", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("code", "Code", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("trans_account", "Network ID", false, true,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("chargeType", "Type of Charge", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("responsibleParty", "Responsible Party", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("total_amount", "Total", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("amountDue", "Due", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("status_text", "Status", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("additional_note", "Note", false, false,
        new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
      new iceColumnDefinition("QuickActions", "", false, false),
      new iceColumnDefinition("medical_service_index_key", "medical_service_index_key", false, true),
      new iceColumnDefinition("medical_service_key", "medical_service_key", true)
    ];
  }

  onGetActionItems(): any[] {
    if (ServiceViews.ViewByBucket == this.currentView) {
      return [IceTypes.recordQuickActionViewBucket,
      IceTypes.recordQuickActionViewBalance,
      IceTypes.recordQuickActionRemove];
    }
    return [
      IceTypes.recordQuickActionEdit,
      IceTypes.recordQuickActionViewBucket,
      IceTypes.recordQuickActionViewBalance,
      IceTypes.recordQuickActionDelete];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }

  getAllStatuses(): any[] {
    let ary = MessageService.getAccountItemStatues();
    ary.push({ value: -1, name: "All" })
    return ary;
  }

  showRecurringChargeButton(): boolean {
    let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
    if (ctrType != null) {
      typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
    }
    return typeOfDomain == IceTypes.ACCOUNT_TYPE.actSubscriber;
  }

  searchBills() {
    this.refreshTableData([]);

    let domType = this.domainTypeCtrl.getFormControl().value;
    let domval = this.domainCtrl.getFormControl().value;
    let fromDt = this.fromDateCtrl.getFormControl().value;
    let toDt = this.toDateCtrl.getFormControl().value;
    let status = this.statusCtrl.getFormControl().value;
    let dom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0)
        dom = domObj[0].value;
    }
    catch (e) {
      dom = "";
    }

    let appSvc = this.getAppService();
    let curAct = appSvc.getCurrentAccount();
    let curActType = appSvc.getCurrentAccountType();
    this.tables[0].setLoading(true);

    this.accSvc.getBills(curAct, curActType, dom, domType, Iceutility.GetDateText(fromDt, '-', false), Iceutility.GetDateText(toDt, '-', false), "CREATED", status).subscribe(
      data => {
        if (data == null || data.length == 0) {
          this.refreshTableData([]);
          return;
        }

        let bills: superbillchargesindex[] = <superbillchargesindex[]>data;

        let datasrc = [];
        for (let i = 0; i < bills.length; i++) {
          let tempidx: superbillchargesindex = bills[i];
          if (tempidx == null) continue;

          let createdate = Iceutility.isTextDateTime(tempidx.created) ? Iceutility.getDateTextEx(tempidx.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempidx.created));
          let modifieddate = Iceutility.isTextDateTime(tempidx.modified) ? Iceutility.getDateTextEx(tempidx.modified) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempidx.modified));
          tempidx.created = createdate;
          tempidx.modified = modifieddate;
          tempidx["to_trans_account_text"] = tempidx.to_trans_account.substr(0, 10);
          tempidx["to_account_type_text"] = DomainService.getDomainType(Iceutility.toLong(tempidx.to_account_type));
          tempidx["bill_status_text"] = MessageService.getStatus(Iceutility.toLong(tempidx.bill_status), IceTypes.SourceType.srcStatement);
          datasrc.push(tempidx);
        }

        this.refreshTableData(data);
      }, error => {
        this.refreshTableData([]);
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });
  }

  searchServices() {
    this.refreshTableData([]);
    this.currentCharge = null;
    this.currentBucket = null;
    this.currentChargeCaption = "Add Service Charge";
    this.currentBucketChargeList = [];
    this.currentChargeHistory.resetHistoryData();
    this.responsibleParties = [];

    let domType = this.domainTypeCtrl.getFormControl().value;
    let domval = this.domainCtrl.getFormControl().value;
    let fromDt = this.fromDateCtrl.getFormControl().value;
    let toDt = this.toDateCtrl.getFormControl().value;
    let keywd = this.keywordCtrl.getFormControl().value;
    let code = this.codeCtrl.getFormControl().value;
    let status = this.statusCtrl.getFormControl().value;
    let appSvc = this.getAppService();
    let dom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0) {
        dom = domObj[0].value;
        this.loadResponsibleParties(domType, dom, domObj[0].name);
      }
    }
    catch (e) {
      dom = "";
    }

    let curAct = appSvc.getCurrentAccount();
    let curActType = appSvc.getCurrentAccountType();
    keywd = !Iceutility.isdefined(keywd) ? "" : keywd;
    code = !Iceutility.isdefined(code) ? "" : code;
    this.tables[0].setLoading(true);

    this.accSvc.getServices(curAct, curActType, dom, domType, Iceutility.GetDateText(fromDt, '-', false), Iceutility.GetDateText(toDt, '-', false), keywd, code, status).subscribe(
      data => {
        if (data == null || data.length == 0) {
          this.refreshTableData([]);
          return;
        }
        let svcs: medicalserviceindex[] = <medicalserviceindex[]>data;
        let datasrc = [];
        for (let i = 0; i < svcs.length; i++) {
          let tempidx: medicalserviceindex = svcs[i];
          if (tempidx == null) continue;
          if (Iceutility.isStringUndefinedNullOrEmpty(tempidx.medical_service_key)) {
            this.deleteTheseServices.push(tempidx);
            continue;
          }
          datasrc.push(tempidx);
          this.updateServiceRecord(tempidx, false, curActType, curAct, domType, dom);
        }

        this.refreshTableData(datasrc);
      }, error => {
        this.refreshTableData([]);
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });
  }

  getViewOptions(): any[] {
    return [
      { name: "Service by Bucket", value: ServiceViews.ViewByBucket },
      { name: "List of Services", value: ServiceViews.ViewByService }
    ];
  }

  viewSetup(dat: IIceEntity[], feature: userTypes.USER_FEATURES): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = super.viewSetup(dat, feature);
    if (setup != null) {
      try {
      }
      catch (e) {
        console.log(e);
      }
    }
    return setup;
  }

  disableSearchButton(): boolean {
    if (this.currentView == ServiceViews.ViewByService
      || this.currentView == ServiceViews.ViewByClaim) {
      let domval = this.domainCtrl.getFormControl().value;
      let dom = "";
      try {
        let domObj = JSON.parse(domval);
        if (domObj != null && domObj.length > 0) {
          dom = domObj[0].value;
        }
      }
      catch (e) {
        dom = "";
      }

      return dom == null || dom.length == 0;
    }
    return false;
  }

  updateNetworkName(resetSort: boolean = false) {
    if (this.statementsViewSettings.rows.length == 0) return;
    if (this.statementsViewSettings.rows[0].columns.length == 0) return;

    let domval = this.domainCtrl.getFormControl().value;
    let dom = "";
    let nameOfDom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0) {
        dom = domObj[0].value;
        nameOfDom = domObj[0].name;
      }
    }
    catch (e) {
      dom = "";
      nameOfDom = "";
    }

    if (dom != null && dom.length > 0) {
      this.statementsViewSettings.rows[0].columns[0].title = nameOfDom + " Network ID: #" + dom;
      this.breadcrumbService.updateBreadcrumbs({
        TREE: this.getAccountingBreadcrumb(),
        YARD: {
          display: nameOfDom,
          data: { account: dom, patientName: nameOfDom },
          active: true,
          link: `/accounting/servicechargehistory/${dom}`,
          history: []
        }
      });
    }
    else {
      if (this.currentView == ServiceViews.ViewByBucket) {
        this.statementsViewSettings.rows[0].columns[0].title = "Search All or " + this.domainCtrl.placeholder;
      }
      else {
        this.statementsViewSettings.rows[0].columns[0].title = this.domainCtrl.placeholder;
      }

      this.currentCharge = null;
      this.currentBucket = null;
      this.currentChargeCaption = "Add Service Charge";
      this.currentBucketChargeList = [];
      this.currentChargeHistory.resetHistoryData();
      this.responsibleParties = [];
      this.refreshTableData([], resetSort);
    }
  }

  updateServiceRecord(tempidx: any, calcPaid: boolean, domType: IceTypes.ACCOUNT_TYPE, dom: string, forDomType: IceTypes.ACCOUNT_TYPE, forDom: string) {
    if (tempidx == null) return;

    this.codeSvc.dateConvert(tempidx, "date_required");
    this.codeSvc.dateConvert(tempidx, "end_date_required");

    tempidx["chargeType"] = AccountingService.getCoaType(tempidx["inc_coa_type"]);
    tempidx["status_text"] = MessageService.getStatus(Iceutility.toLong(tempidx["trans_status"]), IceTypes.SourceType.srcStatement);
    tempidx["amountDue"] = Iceutility.toDouble(tempidx["total_amount"]);
    setTimeout(() => {
      let respartyKey = AccountingService.getPartyBucketKeyEx(tempidx["subscriber_key"], tempidx["coverage_key"], tempidx["payer_key"]);
      let foundResP = this.responsibleParties.filter(r => r.value == respartyKey);
      if (foundResP.length > 0) {
        tempidx["responsibleParty"] = foundResP[0].name;
      }
    }, 1000);


    this.currentChargeHistory.setService(tempidx["medical_service_key"], {});
    this.currentChargeHistory.setServiceAmountDue(tempidx["medical_service_key"], tempidx["amountDue"]);
    this.accSvc.getJournal(dom, domType, "", "", IceTypes.JournalType.jtAsset, IceTypes.coa_types.coaAsset, tempidx["medical_service_key"], IceTypes.coa_types.coaDeductibleAR).subscribe(
      data => {
        if (data != null) {
          let credits = AccountingService.updateChargeHistoryPostingData(this.accSvc, dom, domType,
            this.currentChargeHistory, tempidx, data);
          tempidx["amountDue"] = tempidx["amountDue"] - credits;
          if (calcPaid)
            tempidx["amountPaid"] = credits;

          this.currentChargeHistory.setServiceAmountDue(tempidx["medical_service_key"], tempidx["amountDue"]);
        }
      },
      error => {
        console.log(error);
      });

    this.accSvc.getJournal(dom, domType, "", "", IceTypes.JournalType.jtExpense, IceTypes.coa_types.coaDiscount, tempidx["medical_service_key"], IceTypes.coa_types.coaCorrectionandReversalsAdjustment).subscribe(
      data => {
        if (data != null) {
          this.currentChargeHistory.setServiceExpenses(tempidx["medical_service_key"], data);
        }
      },
      error => {
        console.log(error);
      });

    this.accSvc.getClaims(dom, domType, forDom, forDomType, "", "", "", "", -1, tempidx["medical_service_key"]).subscribe(
      data => {
        if (data == null || data.length == 0) {
          return;
        }
        this.currentChargeHistory.setClaims(tempidx["medical_service_key"], data);
      }, error => {
        console.log(JSON.stringify(this.accSvc.getLastErrors()));
      });

    this.accSvc.getJournal(dom, domType, "", "", IceTypes.JournalType.jtIncome, IceTypes.coa_types.coaRevenue, tempidx["medical_service_key"], IceTypes.coa_types.coaCoInsuranceIncome).subscribe(
      data => {
        if (data != null) {
          this.currentChargeHistory.setServiceIncomes(tempidx["medical_service_key"], data);
          let chargeType = IceTypes.coa_types.coaNone;
          for (let ijrnl = 0; ijrnl < data.length; ijrnl++) {
            let jrnl: incomerevenuejournal = data[ijrnl];
            if (chargeType == IceTypes.coa_types.coaNone)
              chargeType = Iceutility.toLong(jrnl.coa_type);
          }
          tempidx["chargeType"] = AccountingService.getCoaType(chargeType);
        }
      },
      error => {
        console.log(error);
      });

  }

  loadResponsibleParties(domType: IceTypes.ACCOUNT_TYPE, dom: string, nameOfDom: string) {
    let appSvc = this.getAppService();
    if (this.responsibleParties.length == 0) {
      let optForBillTo = nameOfDom + " (" + DomainService.getDomainType(domType) + ", Cash Pay)";
      this.responsibleParties = [{ name: optForBillTo, value: "", summary: [] }];
    }
    if (domType == IceTypes.ACCOUNT_TYPE.actPatient && this.responsibleParties.length <= 1) {
      this.patSvc.getPatientSubscriberRefs(dom, appSvc.getCurrentAccount(), appSvc.getCurrentAccountType()).subscribe(
        data => {
          if (data != null) {
            this.patientSubRefs = data;
            this.patSvc.getPatientSubscribers(dom, appSvc.getCurrentAccount(), appSvc.getCurrentAccountType()).subscribe(
              subdata => {
                if (subdata != null && this.responsibleParties.length <= 1) {
                  let pyrCovs = null;
                  for (let isub = 0; isub < subdata.length; isub++) {
                    let sub: subscriber = subdata[isub];
                    if (sub.COVGS.length > 0) {
                      if (pyrCovs == null || pyrCovs.length == 0)
                        pyrCovs = this.patSvc.getPayerCoverageBenefits(sub, true, this.patientSubRefs, this.listOfPayerResponsibities);

                      if (pyrCovs != null) {
                        for (let icov = 0; icov < pyrCovs.length; icov++) {
                          let covDtl = pyrCovs[icov];
                          this.responsibleParties.push({
                            name: covDtl["payer_name"],
                            value: covDtl["payer_id"],
                            summary: covDtl.summary
                          });
                        }
                      }
                    }
                  }
                }
              },
              error => {
                console.log(error);
              });
          }
        },
        err => {

        });
    }
  }

  loadTemplateServiceAndInventory(domType: IceTypes.ACCOUNT_TYPE) {
    let appSvc = this.getAppService();
    if (this.listOfServices.length == 0) {
      this.accSvc.getBillTemplates(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), domType, "").subscribe(
        billTemplates => {
          if (billTemplates == null || billTemplates.length == 0) {
            return;
          }

          for (let i = 0; i < billTemplates.length; i++) {
            let tempidx: superbillindex = billTemplates[i];
            if (tempidx == null) continue;

            this.accSvc.getBillTemplate(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), tempidx.superbill_key).subscribe(
              superbillData => {
                if (superbillData && superbillData.length > 0) {
                  let superbill = superbillData[0],
                    subtypes = superbill.SUBTYPES;

                  for (var isubtype = 0; isubtype < subtypes.length; isubtype++) {
                    let subtype = subtypes[isubtype];
                    if (subtype == null) continue;

                    let codes = subtype.CODES;
                    for (var icode = 0; icode < codes.length; icode++) {
                      let code: basecodereference = codes[icode];
                      if (code == null) continue;

                      let obj = {
                        value: code.code,
                        name: code.title,
                        code: code.code,
                        price: code.price,
                      };
                      this.listOfServices.push(obj);
                    }
                  }
                }
              },
              error => {
                console.log(JSON.stringify(this.accSvc.getLastErrors()));
              });
          }
        }, error => {
          console.log(JSON.stringify(this.accSvc.getLastErrors()));
        });
    }

    if (this.listOfInventory.length == 0) {
      this.accSvc.getOtherItems(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), "*" /*all*/).subscribe(
        data => {
          if (data == null || data.length == 0) {
            return;
          }
          for (let iresult = 0; iresult < data.length; iresult++) {
            let item: otheritemsindex = data[iresult];

            let obj = {
              value: item.item_stock_num,
              name: item.itm_name,
              code: item.item_stock_num,
              price: item.price,
              key: item.other_items_key
            };
            this.listOfInventory.push(obj);
          }
        },
        error => {
          // To do, log error
        });
    }
  }

  showKeyword() {
    return (this.currentView == ServiceViews.ViewByService || this.currentView == ServiceViews.ViewByAged)
  }

  showCode() {
    return (this.currentView == ServiceViews.ViewByService || this.currentView == ServiceViews.ViewByAged)
  }

  initializeCurrentChargePanel(event: any) {
    setTimeout(() => {
      if (this.currentChargePanel != null) {
        if (this.currentChargePanel.getInitializeEvent() != null) {
          this.currentChargePanel.getInitializeEvent().emit(event);
        }
      }
    });
  }

  createBucketAndRedirect(curDomType, curDom, svcidx: medicalserviceindex, redirectToBucket: boolean) {
    if (svcidx == null) return;

    if (false == Iceutility.yesnomodal("No Bucket exists for this service. Would you like to create a new bucket? \nOK - To Create or Cancel to skip bucket creation.")) return;
    let chrgRef: medicalservicereference = new medicalservicereference();
    chrgRef.medical_service_reference_key = Iceutility.guid(true);
    chrgRef.medical_service_key = svcidx.medical_service_key;

    let domval = this.domainCtrl.getFormControl().value;
    let nameOfDom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0) {
        nameOfDom = domObj[0].name;
      }
    }
    catch (e) {
      nameOfDom = "";
    }

    this.currentBucket = new superbillcharges();
    this.currentBucket.from_account_type = curDomType;
    this.currentBucket.from_trans_account = curDom;
    this.currentBucket.to_account_type = svcidx.account_type;
    this.currentBucket.to_trans_account = svcidx.trans_account;
    this.currentBucket.bill_status = IceTypes.trans_status.isNone;
    this.currentBucket.bill_to = nameOfDom;
    this.currentBucket.CHARGES.push(chrgRef);
    this.accSvc.insertBill(curDom, curDomType, this.currentBucket).subscribe(
      data => {
        if (data != null && data.length > 0) {
          let bills: superbillcharges[] = <superbillcharges[]>data;
          this.getRouter().navigate([this.getNavService().buildRoute((redirectToBucket ? "accounting/serviceitemcharge/" : "accounting/outstandingbalance/") + bills[0].superbill_charges_key, false)]);
        }
      },
      error => {
        console.log(error);
      });
  }

  subscriptionChargePopup(event) {
    let superBillPackage: superbillcharges = null;
    let packageDetails: medicalservice[] = [];
    let sections: IcepanelsectionSettings[] = [];

    let startDateCtrl: IcecontrolSettings = null;
    let freqValueCtrl: IcecontrolSettings = null;
    let freqCtrl: IcecontrolSettings = null;
    let ownersCtrl: IcecontrolSettings = null;

    let addChargeType: IcecontrolSettings = null;
    let addDescCtrl: IcecontrolSettings = null;
    let addQuantity: IcecontrolSettings = null;
    let addUnitPrice: IcecontrolSettings = null;
    let addTotalAmount: IcecontrolSettings = null;

    let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
    if (ctrType != null) {
      typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
    }

    this.loadTemplateServiceAndInventory(typeOfDomain);

    try {
      superBillPackage = new superbillcharges();
      sections.push(
        new IcepanelsectionSettings("SubscriptionOwner", { class: ["yalla"], styles: {} }, [],
          [
            ownersCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "300px" }, null, null, "trans_account", "Owner of Subscription")
              .setControlName("trans_account")
              .createFormControl(this.lastRecurringDomains, [Validators.required])
              .setMultipleSelection(true)
          ], null),
        new IcepanelsectionSettings("SubscriptionFrequency", { class: ["yalla"], styles: {} }, [],
          [
            freqCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "300px" }, null, null, "frequency", "Frequency")
              .setControlName("frequency")
              .createFormControl(IceTypes.recurringtype.recurtypeWeekly, [Validators.required])
              .setOptions([
                { value: IceTypes.recurringtype.recurtypeOneTime, name: "One-Time" },
                { value: IceTypes.recurringtype.recurtypeDaily, name: "Day(s)" },
                { value: IceTypes.recurringtype.recurtypeWeekly, name: "Week(s)" },
                { value: IceTypes.recurringtype.recurtypeMonthly, name: "Month(s)" },
                { value: IceTypes.recurringtype.recurtypeYearly, name: "Year(s)" },
              ]),
            freqValueCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "300px" }, null, null, "frequency_value", "No. of Days, Weeks, etc.")
              .setControlName("frequency_value")
              .createFormControl(1, [Validators.required])
              .setMultipleSelection(true),
            startDateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "Start of Period", width: "175px" }, null, null, "Start of Period")
              .setControlName("start_date")
              .createFormControl(Iceutility.GetLocalDate(), [Validators.required])
          ], null),
        new IcepanelsectionSettings("AddItemSection", { class: ["yalla"], styles: {} }, [],
          [
            addChargeType = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "charge_type", "Type of Charge")
              .setControlName("charge_type")
              .createFormControl(IceTypes.coa_types.coaServiceIncome, [Validators.required])
              .setOptions([
                { value: IceTypes.coa_types.coaServiceIncome, name: "Service" },
                { value: IceTypes.coa_types.coaOtherIncome, name: "Other Item" },
              ]),
            addDescCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "300px" }, null, null, "service", "Item to Add")
              .setControlName("service")
              .createFormControl("", [Validators.required])
              .setOptions(this.listOfServices),
            addQuantity = new IcecontrolSettings("iceinput", { width: "100%", inputType: "number" }, null, null, "Quantity", "quantity")
              .setControlName("quantity")
              .createFormControl(0.0, []),
            addUnitPrice = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "Price", "Price")
              .setControlName("price")
              .createFormControl(0.0, []),
            addTotalAmount = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "TotalAmount", "Total Amount")
              .setControlName("total_amount")
              .createFormControl(0.0, [])
              .setReadonly(true)
          ], null),
      );
    }
    catch (e) {
      console.log(e);
      return;
    }

    ownersCtrl.placeholder = "Enter " + DomainService.getDomainType(typeOfDomain);
    ownersCtrl.createQueryControlEvent().subscribe(
      event => {
        let appSvc = this.getAppService();
        switch (typeOfDomain) {
          case IceTypes.ACCOUNT_TYPE.actPatient: {
            appSvc.setDomainNameList(ownersCtrl, true, this.domainSvc.getPatientsByKeyword(appSvc.getCurrentAccountType(), appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
            break;
          }
          case IceTypes.ACCOUNT_TYPE.actSubscriber: {
            appSvc.setDomainNameList(ownersCtrl, true, this.domainSvc.getSubscribersByKeyword(appSvc.getCurrentAccountType(), appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
            break;
          }
        }
      },
      error => {
      }
    );

    addChargeType.createChangeControlEvent().subscribe(
      event => {
        let ct: IceTypes.coa_types = event.value;
        addDescCtrl.setOptions(IceTypes.coa_types.coaServiceIncome == ct ? this.listOfServices : this.listOfInventory);

        addQuantity.getFormControl().setValue(0.0);
        addUnitPrice.getFormControl().setValue(0.0);
        addTotalAmount.getFormControl().setValue(0.0);
      }
    );

    addDescCtrl.createChangeControlEvent().subscribe(
      event => {
        let svcDescCtrl: IcecontrolSettings = <IcecontrolSettings>event.autocompleteSettings;
        let selected = null;
        try {
          selected = JSON.parse(svcDescCtrl.getFormControl().value);
          if (selected != null && selected.length > 0)
            selected = selected[0]
          else
            throw "Unable to parse service selected";
        }
        catch (e) {
          console.log(e);
          return;
        }

        let chrgeType: IceTypes.coa_types = addChargeType.getFormControl().value;
        let thisList = null;
        if (chrgeType == IceTypes.coa_types.coaServiceIncome) {
          thisList = this.listOfServices;
        }
        else if (chrgeType == IceTypes.coa_types.coaOtherIncome) {
          thisList = this.listOfInventory;
        }
        else {
          return;
        }

        let svcs = thisList.filter(s => s.code == selected.value);
        if (svcs.length > 0) {
          let qty = 1.0;
          addQuantity.getFormControl().setValue(qty);
          let price = Iceutility.toDouble(svcs[0].price);
          addUnitPrice.getFormControl().setValue(price);
          let total = price * qty;
          addTotalAmount.getFormControl().setValue(total);
        }
      }
    );

    addQuantity.createChangeControlEvent().subscribe(
      event => {
        let newQty = Iceutility.toDouble(event.currentTarget.value);
        let price = Iceutility.toDouble(addUnitPrice.getFormControl().value);
        let total = price * newQty;
        addTotalAmount.getFormControl().setValue(total);
      });

    addQuantity.createKeyUpControlEvent().subscribe(
      event => {
        let newQty = Iceutility.toDouble(addQuantity.getFormControl().value);
        let price = Iceutility.toDouble(addUnitPrice.getFormControl().value);
        let total = price * newQty;
        addTotalAmount.getFormControl().setValue(total);
        addQuantity.getFormControl().setValue(newQty);
      });

    addUnitPrice.createKeyUpControlEvent().subscribe(
      event => {
        let qty = Iceutility.toDouble(addQuantity.getFormControl().value);
        let newPrice = Iceutility.toDouble(addUnitPrice.getFormControl().value);
        let total = newPrice * qty;
        addTotalAmount.getFormControl().setValue(total);
        if (event.key == ".") return;
        addUnitPrice.getFormControl().setValue(newPrice);
      });

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.recurringChargesDialogRef = this.dialog.open(IcepanelDialog, {
      height: '500px',
      width: '500px',
      data: {
        record: packageDetails,
        parentrecord: superBillPackage,
        panel: new IcepanelSettings("", "", "Recurring Charge(s)", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.recurringChargesDialogRef;
    this.recurringChargesDialogRef.afterClosed().subscribe(result => {
      debugger;
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let svcs: medicalservice[] = <medicalservice[]>ref.componentInstance.data.record;
      let billPackage: superbillcharges = <superbillcharges>ref.componentInstance.data.parentrecord;
      let frequency: IceTypes.recurringtype = IceTypes.recurringtype.recurtypeWeekly;
      let frequencyVal: number = 1;
      let stDate: string = "";
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && billPackage != null && svcs != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "trans_account": {
                  try {
                    this.lastRecurringDomains = ctrl.getFormControl().value;
                    let supOwnersObj = JSON.parse(ctrl.getFormControl().value);
                    if (supOwnersObj != null && supOwnersObj.length > 0) {
                      let trans = [];
                      for (let o = 0; o < supOwnersObj.length; o++) {
                        trans.push(supOwnersObj[o]["value"]);
                      }
                      billPackage.to_account_type = typeOfDomain;
                      billPackage.to_trans_account = trans.join(",");
                    }
                    else {
                      throw "No provider selected or error saving provider.";
                    }
                  }
                  catch (e) {
                    this.accSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, e);
                  }
                  break;
                }
                case "frequency": {
                  frequency = ctrl.getFormControl().value;
                  break;
                }
                case "frequency_value": {
                  frequencyVal = ctrl.getFormControl().value;
                  break;
                }
                case "charge_type": {
                  let svc = new medicalservice();
                  svc.inc_coa_type = ctrl.getFormControl().value
                  svcs.push(svc);
                  break;
                }
                case "service": {
                  try {
                    let sObj = JSON.parse(ctrl.getFormControl().value);
                    if (sObj != null && sObj.length > 0) {
                      if (IceTypes.coa_types.coaServiceIncome == svcs[svcs.length - 1].inc_coa_type) {
                        svcs[svcs.length - 1].code = sObj[0]["value"];
                        svcs[svcs.length - 1].service_description = sObj[0]["name"];
                      }
                      else {
                        svcs[svcs.length - 1].other_items_key = sObj[0]["value"]; // for now the item_stock_num is used here, server will re-assign it
                        svcs[svcs.length - 1].service_description = sObj[0]["name"];
                      }
                    }
                    else {
                      throw "No service or inventory selected.";
                    }
                  }
                  catch (e) {
                    this.accSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, e);
                  }
                  break;
                }
                case "start_date": {
                  stDate = Iceutility.convertToUTCEx(ctrl.getFormControl().value);
                  break;
                }
                case "quantity": {
                  svcs[svcs.length - 1].quantity = Iceutility.toDouble(ctrl.getFormControl().value);
                  break;
                }
                case "price": {
                  svcs[svcs.length - 1].price = Iceutility.toDouble(ctrl.getFormControl().value);
                  break;
                }
                case "total_amount": {
                  svcs[svcs.length - 1].total_amount = Iceutility.toDouble(ctrl.getFormControl().value);
                  break;
                }
              }
            }
          }

          this.accSvc.processRecurringCharges(this.getAppService().getCurrentAccount(),
            this.getAppService().getCurrentAccountType(), billPackage, frequency, frequencyVal, stDate, svcs).subscribe(
              data => {
                if (data == null || data.length == 0) {
                  // to do reload popup to try again.
                  this.accSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Failed to process charges.");
                  return;
                }

                this.filterButtonClick({});
              },
              error => {
                console.log(JSON.stringify(error))
                this.accSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Processing charges.");
              }
            );

        }
      }
    });

  }

  /////////////////////////////////////
  // Events
  onPeriodActionRequired(event) {
    debugger;
    if (event.value == "NoCurrentPeriod")
      this.hideAccountingPeriod = false;
    else
      this.hideAccountingPeriod = true;
  }

  viewOptionsSelectChange(event) {
    this.currentView = event.value;
    this.refreshTableData([]);
    this.tables[0].iColumns = this.onGetColumnDefinition();
    this.tables[0].actionItems = this.onGetActionItems();
    this.updateNetworkName();

    const selectedOption = event.selectSettings.options.find(o => o.value === event.value);
    const selectedName = selectedOption ? selectedOption.name : '';
    this.breadcrumbService.updateBreadcrumbs({
      TREE: this.getAccountingBreadcrumb(),
      BRANCH: { display: `Service charge history - ${selectedName}`, data: null, active: true, link: "", history: [] }
    });
  }

  domainSearch(event) {
    let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
    if (ctrType != null) {
      typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
    }
    let appSvc = this.getAppService();
    switch (typeOfDomain) {
      case IceTypes.ACCOUNT_TYPE.actPatient: {
        appSvc.setDomainNameList(this.domainCtrl, true, this.domainSvc.getPatientsByKeyword(appSvc.getCurrentAccountType(), appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actSubscriber: {
        appSvc.setDomainNameList(this.domainCtrl, true, this.domainSvc.getSubscribersByKeyword(appSvc.getCurrentAccountType(), appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
        break;
      }
    }
  }

  domainChange(event) {
    if (this.statementsViewSettings.rows.length == 0) return;
    if (this.statementsViewSettings.rows[0].columns.length == 0) return;

    let autoCmp: IcecontrolSettings = <IcecontrolSettings>event.autocompleteSettings;
    if (autoCmp == null) {
      this.statementsViewSettings.rows[0].columns[0].title = "";
    }

    this.updateNetworkName();
  }

  domainTypeSelectChange(event) {
    this.domainCtrl.setOptions([]);

    let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
    if (ctrType != null) {
      typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
    }

    this.domainCtrl.placeholder = "Enter " + DomainService.getDomainType(typeOfDomain);
    this.updateNetworkName();
    switch (typeOfDomain) {
      case IceTypes.ACCOUNT_TYPE.actPatient: {
        if (this.listOfPayerResponsibities.length == 0) {
          this.codeSvc.getCodes("PAYER_RESPONSIBILITY_SEQUENCE_NUMBER", "", "", "").subscribe(
            data => {
              if (data && data.length > 0) {
                this.listOfPayerResponsibities = <basecode[]>data;
              }
            },
            error => {
              // To do
            });
        }

        // Fall through and do lookup upon keyword search        
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actProvider:
      case IceTypes.ACCOUNT_TYPE.actFacility: {
        this.getAppService().setDomainNameList(this.domainCtrl, true, this.proSvc.getProviders());
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actPharmacy: {
        this.getAppService().setDomainNameList(this.domainCtrl, true, this.pharmSvc.getPharmacies());
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actVendor: {
        this.getAppService().setDomainNameList(this.domainCtrl, true, this.vendorSvc.getVendors());
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actPayer: {
        this.getAppService().setDomainNameList(this.domainCtrl, true, this.payerSvc.getPayers());
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actSubscriber: {
        // Fall through and do lookup upon keyword search
        break;
      }
      default: {
        // To do error to user
        return;
      }
    }
  }

  filterButtonClick(event) {
    if (this.currentView == ServiceViews.ViewByBucket)
      this.searchBills();
    else
      this.searchServices();
  }

  resetButtonClick(event) {
    // clear the search criteria
    this.currentView = ServiceViews.ViewByService;
    this.viewOptions.getFormControl().reset();
    this.viewOptions.getFormControl().setValue(ServiceViews.ViewByService);
    this.domainCtrl.getFormControl().reset();
    this.domainCtrl.setOptions([], true);
    this.domainCtrl.placeholder = "Enter " + DomainService.getDomainType(IceTypes.ACCOUNT_TYPE.actPatient);
    this.domainTypeCtrl.getFormControl().setValue(IceTypes.ACCOUNT_TYPE.actPatient);
    this.fromDateCtrl.getFormControl().reset();
    this.toDateCtrl.getFormControl().reset();
    this.codeCtrl.getFormControl().reset();
    this.statusCtrl.getFormControl().setValue(-1);
    this.keywordCtrl.getFormControl().reset();
    this.updateNetworkName(true);
  }

  onControlChange(event) {
  }

  onButtonClick(event) {
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        case filterButton: {
          break;
        }
      }
    }
  }

  public onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        case "Table": {
          let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
          let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
          if (ctrType != null) {
            typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
          }

          let domval = this.domainCtrl.getFormControl().value;
          let dom = "", nameOfDom = "";
          try {
            let domObj = JSON.parse(domval);
            if (domObj != null && domObj.length > 0) {
              dom = domObj[0].value;
              nameOfDom = domObj[0].name;
            }
          }
          catch (e) {
            dom = "";
            nameOfDom = "";
          }
          let nameOfType = DomainService.getDomainType(typeOfDomain);
          if (dom.length == 0 && ServiceViews.ViewByService == this.currentView) {
            if (false == Iceutility.yesnomodal("You must enter/select a " + nameOfType + " to add a new service.\nChoose:\nOK - To add a new Service Bucket or\nCancel - To Enter a " + nameOfType))
              return;
            else
              this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/0", false)]);
          }

          if (ServiceViews.ViewByService == this.currentView) {
            this.currentChargeCaption = "Add Service Charge";
            this.loadTemplateServiceAndInventory(typeOfDomain);
            this.loadResponsibleParties(typeOfDomain, dom, nameOfDom);
            this.currentCharge = new medicalservice();
            this.currentCharge.trans_account = dom;
            this.currentCharge.account_type = typeOfDomain;
            this.currentCharge.inc_coa_type = IceTypes.coa_types.coaServiceIncome;
            this.currentBucket = null;
            this.currentBucketChargeList = [];
            this.initializeCurrentChargePanel(event);
          }
          else if (ServiceViews.ViewByBucket == this.currentView) {
            if (dom.length == 0)
              this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/0", false)]);
            else
              this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemchargebydomain/" + typeOfDomain.toString() + "/" + dom + "/0", false)]);
          }
          break;
        }
      }
    }
  }

  onItemDoneClick(event): void {
    let appSvc = this.getAppService();
    let curDom = appSvc.getCurrentAccount();
    let curDomType = appSvc.getCurrentAccountType();

    let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
    if (ctrType != null) {
      typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
    }

    let domval = this.domainCtrl.getFormControl().value;
    let dom = "";
    let nameOfDom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0) {
        dom = domObj[0].value;
        nameOfDom = domObj[0].name;
      }
    }
    catch (e) {
      dom = "";
      nameOfDom = "";
    }

    if (this.currentCharge.medical_service_key.length == 0) {
      this.accSvc.insertServices(curDom, curDomType, this.currentCharge).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let newSvc: medicalservice = data[0];
            let newSvcIdx = new medicalserviceindex().copyservice(newSvc);
            let datasrc = this.getTableData();
            if (datasrc == null || datasrc.length == 0) {
              datasrc = [];
              datasrc.push(newSvcIdx);
            }
            else {
              datasrc.unshift(newSvcIdx);
            }

            this.updateServiceRecord(newSvcIdx, false, curDomType, curDom, typeOfDomain, dom);

            this.refreshTableData(datasrc);

            let chrgRef: medicalservicereference = new medicalservicereference();
            chrgRef.medical_service_reference_key = Iceutility.guid(true);
            chrgRef.medical_service_key = newSvc.medical_service_key;

            if (this.currentBucket != null) {
              this.currentBucket.CHARGES.push(chrgRef);
              this.accSvc.updateBill(curDom, curDomType, this.currentBucket).subscribe(
                data => {
                },
                error => {
                  console.log(error);
                });
            }
            else {
              this.currentBucket = new superbillcharges();
              this.currentBucket.from_account_type = curDomType;
              this.currentBucket.from_trans_account = curDom;
              this.currentBucket.to_account_type = typeOfDomain;
              this.currentBucket.to_trans_account = dom;
              this.currentBucket.bill_status = IceTypes.trans_status.isNone;
              this.currentBucket.bill_to = nameOfDom;
              this.currentBucket.CHARGES.push(chrgRef);
              this.accSvc.insertBill(curDom, curDomType, this.currentBucket).subscribe(
                data => {
                },
                error => {
                  console.log(error);
                });
            }

            if (event.addContinue) {
              this.currentCharge = new medicalservice();
              this.currentCharge.trans_account = dom;
              this.currentCharge.account_type = typeOfDomain;
              this.currentCharge.inc_coa_type = IceTypes.coa_types.coaServiceIncome;
              this.currentBucketChargeList = [];
              this.initializeCurrentChargePanel(event);
            }
          }
        },
        error => {
          console.log(error);
        });
    }
    else {
      this.accSvc.updateServices(curDom, curDomType, [this.currentCharge]).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let updatedSvc: medicalservice = data[0];
            let datasrc = this.getTableData();
            if (datasrc != null) {
              let foundSvc = datasrc.filter(svc => svc.medical_service_key == updatedSvc.medical_service_key);
              if (foundSvc.length > 0) {
                let postdata = this.currentChargeHistory.getAllServicePostings(updatedSvc.medical_service_key);
                for (const postkey in postdata) {
                  let thispost: payment = postdata[postkey];
                  if (thispost.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
                    this.accSvc.postOneChargePayment(curDom, curDomType, thispost).subscribe(
                      postdata => {
                        this.searchServices();
                      },
                      posterror => {
                      });
                  }
                }

                let updatedSvcIdx: medicalserviceindex = <medicalserviceindex>foundSvc[0];
                updatedSvcIdx.copyservice(updatedSvc);
                this.updateServiceRecord(updatedSvcIdx, false, curDomType, curDom, typeOfDomain, dom);
                this.refreshTableData(datasrc);
              }
            }
          }
        },
        error => {
          console.log(error);
        });
    }

    this.currentCharge = null;
    this.currentBucketChargeList = [];
  }

  onItemCancelClick(event): void {
    this.currentCharge = null;
    this.currentBucketChargeList = [];
  }

  onMatGridRowClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }
  }

  onMatGridRowActionClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }

    let appSvc = this.getAppService();
    let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
    if (ctrType != null) {
      typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
    }
    let curDom = appSvc.getCurrentAccount(), curDomType = appSvc.getCurrentAccountType();

    if (IceTypes.RecordActionType.oatViewBucket == event.actionItem.value) {
      this.onRowBucket(event, typeOfDomain);
    }
    else if (IceTypes.RecordActionType.oatViewBalance == event.actionItem.value) {
      this.onRowBalance(event, typeOfDomain);
    }
    else if (IceTypes.RecordActionType.oatEdit == event.actionItem.value) {
      this.onRowEdit(event, typeOfDomain);
    }
    else if (IceTypes.RecordActionType.oatDelete == event.actionItem.value) {
      const medService = <medicalserviceindex>event["rowData"];
      if (Iceutility.toDouble(medService["amountDue"]) !== Iceutility.toDouble(medService.total_amount)) {
        this.showErrorMessage("This service charge cannot be removed because a payment has already been posted.");
        return;
      }

      const medicalServiceKey = medService["medical_service_key"];
      const dataSource = this.getDataSource();
      const index = dataSource.data.findIndex(ch => ch.medical_service_key === medicalServiceKey);
      const headerControls = [
        new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px", tooltip: "Delete" }, null, null, "Delete"),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Close" }, null, null, "Close")
      ];
      const sections = [
        new IcepanelsectionSettings("section1", { class: [""], styles: {} }, [],
          [new IcecontrolSettings("icelabel", { width: "200px", value: `Are you sure you want to remove "${medService.service_description}" service charge?` }, null, null)], null)
      ];
      const params = {
        itemKey: medicalServiceKey
      };

      this.deleteConfirmationDialogRef = this.dialog.open(IcepanelDialog, {
        height: '220px',
        width: '550px',
        data: {
          record: {},
          panel: new IcepanelSettings("", "", "Remove Service Charge?", "", sections, headerControls)
            .enableForm(),
        }
      });

      let dialogRef = this.deleteConfirmationDialogRef;
      this.deleteConfirmationDialogRef.afterClosed().subscribe(result => {
        if (!Iceutility.isdefined(dialogRef.componentInstance) || !Iceutility.isdefined(dialogRef.componentInstance.data)) return;
        let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>dialogRef.componentInstance.data.headerCtrl;
        if (hdrCtrl == null || hdrCtrl.id == "Close") {
          event.source.checked = true;
          event.checked = true;
          return;
        }

        this.loading = true;
        Iceutility.scrollToTop();

        this.accSvc.getBillByService(curDom, curDomType, medService.trans_account, typeOfDomain, medicalServiceKey).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let bills: superbillcharges[] = <superbillcharges[]>data;
              let superBillKey = bills[0].superbill_charges_key;

              this.accSvc.billServiceScanItemRemove(curDom, curDomType, superBillKey, params)
                .subscribe(
                  data => {
                    this.loading = false;
                    dataSource.data.splice(index, 1);
                    this.tables[0].setLoading(true);
                    this.refreshTableData(dataSource.data);
                  },
                  _ => {
                    this.showErrorMessage("Failed to remove the item.");
                    this.loading = false;
                  });
            } else {
              this.showErrorMessage("An error ocurred while fetching the details");
              this.loading = false;
            }
          },
          error => {
            console.log(error);
            this.loading = false;
          });
      });
    }
    else if (IceTypes.RecordActionType.oatRemove == event.actionItem.value) {
      let item = <superbillchargesindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
      this.accSvc.deleteBill(this.getAppService().getCurrentAccount(), this.getAppService().getCurrentAccountType(), item.superbill_charges_key).subscribe(
        data => {
          let dataSrc = this.getDataSource();
          dataSrc.data = dataSrc.data.filter(b => b.superbill_charges_key != item.superbill_charges_key);
        },
        error => {
          // To do, log error
        });
    }
  }

  onRowBucket(event, typeOfDomain: IceTypes.ACCOUNT_TYPE): void {
    let appSvc = this.getAppService();
    let curDom = appSvc.getCurrentAccount(), curDomType = appSvc.getCurrentAccountType();

    if (ServiceViews.ViewByBucket == this.currentView) {
      let item = <superbillchargesindex>event["rowData"];
      this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/" + item.superbill_charges_key, false)], this.navOptions);
    }
    else {
      let item2 = <medicalserviceindex>event["rowData"];
      this.accSvc.getBillByService(curDom, curDomType, item2.trans_account, typeOfDomain, item2.medical_service_key).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let bills: superbillcharges[] = <superbillcharges[]>data;
            this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/" + bills[0].superbill_charges_key, false)], this.navOptions);
          }
          else { // no bill found
            this.createBucketAndRedirect(curDomType, curDom, item2, true);
          }

        },
        error => {
          console.log(error);
        });
    }
  }

  onRowBalance(event, typeOfDomain: IceTypes.ACCOUNT_TYPE): void {
    let appSvc = this.getAppService();
    let curDom = appSvc.getCurrentAccount(), curDomType = appSvc.getCurrentAccountType();

    if (ServiceViews.ViewByBucket == this.currentView) {
      let item = <superbillchargesindex>event["rowData"];
      this.getRouter().navigate([this.getNavService().buildRoute("accounting/outstandingbalance/" + item.superbill_charges_key, false)], this.navOptions);
    }
    else {
      let item2 = <medicalserviceindex>event["rowData"];
      this.accSvc.getBillByService(curDom, curDomType, item2.trans_account, typeOfDomain, item2.medical_service_key).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let bills: superbillcharges[] = <superbillcharges[]>data;
            this.getRouter().navigate([this.getNavService().buildRoute("accounting/outstandingbalance/" + bills[0].superbill_charges_key, false)], this.navOptions);
          }
          else { // no bill found
            this.createBucketAndRedirect(curDomType, curDom, item2, false);
          }
        },
        error => {
          console.log(error);
        });
    }
  }


  onRowEdit(event, typeOfDomain: IceTypes.ACCOUNT_TYPE): void {
    if (event == null) return;

    let appSvc = this.getAppService();
    let curDom = appSvc.getCurrentAccount(), curDomType = appSvc.getCurrentAccountType();

    let item = <superbillchargesindex>event["rowData"];
    if (item == null) {
      // To do log error
      return;
    }
    if (ServiceViews.ViewByService == this.currentView) {
      this.currentCharge = null;
      this.currentChargeCaption = "Edit Service Charge";
      this.currentBucketChargeList = [];
      this.loadTemplateServiceAndInventory(typeOfDomain);

      let item2 = <medicalserviceindex>event["rowData"];
      this.accSvc.getBillByService(curDom, curDomType, item2.trans_account, typeOfDomain, item2.medical_service_key, true).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let bill: superbillcharges = <superbillcharges>data[0];
            if (bill != null) {
              this.loadResponsibleParties(typeOfDomain, bill.to_trans_account, bill.bill_to);
              for (let ichrg = 0; ichrg < bill.CHARGES.length; ichrg++) {
                let chrgRef: medicalservicereference = <medicalservicereference>bill.CHARGES[ichrg];

                let foundMedSvc = data.filter(obj => obj.medical_service_key == chrgRef.medical_service_key);
                if (foundMedSvc.length == 0) continue;
                if (foundMedSvc[0].medical_service_key == item2.medical_service_key)
                  this.currentCharge = foundMedSvc[0];

                // Don't show copays
                if (Iceutility.toLong(foundMedSvc[0].inc_coa_type) != IceTypes.coa_types.coaCoPayIncome)
                  this.currentBucketChargeList.push(foundMedSvc[0]);
              }

              this.initializeCurrentChargePanel(event);
              Iceutility.scrollToTop();
            }
          }
          else {
            this.accSvc.getService(curDom, curDomType, item2.trans_account, typeOfDomain, item2.medical_service_key).subscribe(
              data => {
                if (data != null && data.length > 0) {
                  let domval = this.domainCtrl.getFormControl().value;
                  let nameOfDom = "";
                  try {
                    let domObj = JSON.parse(domval);
                    if (domObj != null && domObj.length > 0) {
                      nameOfDom = domObj[0].name;
                    }
                  }
                  catch (e) {
                    nameOfDom = "";
                  }
                  this.loadResponsibleParties(typeOfDomain, item2.trans_account, nameOfDom);
                  this.currentCharge = <medicalservice>data[0];
                  this.initializeCurrentChargePanel(event);
                  Iceutility.scrollToTop();
                }
              },
              error => {
                console.log(error);
              });
          }
        },
        error => {
          console.log(error);
        });
    }
    else {
    }
  }

  private showErrorMessage(message: string) {
    this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, message);
    Iceutility.scrollToTop();
  }
}
